import moment from "moment";

export const logout = () => {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
};

export const handleResponse = (err) => {
  if (err?.response?.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // eslint-disable-next-line no-restricted-globals
    location.reload(true);
  }

  const error = (err?.response?.data && err?.response?.data.message);
  throw error;
};

export const getChallengeDateFormat = (date) => {
  return moment(date).format("YYYY-MM-DD");
};
